import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { decodeHTML } from "@utils/CommonUtils";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useAuth } from "~/Hooks/useAuth";
import { useDocumentDetails } from "~/Modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { eramanCMSApi, post, put } from "~/Services";
import { eramanHost } from "~/Utils";
import { fields } from "../constants";
import { useAllExpressDocuments } from "./Express.hook";

export const Express = () => {
  const query = useQuery();
  const { openToast } = useNotification();
  const { user } = useAuth();
  const navigate = useNavigate();

  const {
    data: allExpressDocs,
    isLoading: isLoadingExpressDocs,
    refetch: refetchAllExpressDocs,
  } = useAllExpressDocuments(query.get("editId") || "");

  const {
    data: editExpressById,
    isLoading: isLoadingExpress,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    const activeTab = query.get("activeTab");
    const editId = query.get("editId");

    if (activeTab === "eXpress" || editId) {
      refetchAllExpressDocs();
      fetchStoreDropdownData();
    }

    if (query.get("id")) {
      refetchDocument();
      fetchStoreDropdownData();
    }
  }, [query.get("activeTab"), query.get("editId"), query.get("id")]);

  console.log(allExpressDocs, "allExpressDocs");

  const [storeDropdownOptions, setStoreDropdownOptions] = useState<{ label: string; value: string }[]>([]);

  const fetchStoreDropdownData = async () => {
    try {
      const response = await eramanCMSApi.get(`/api/store-location-dropdown`);
      const data = response.data?.data || [];
      const options = data.map((item: { id: string; name: string }) => ({
        value: item.id,
        label: item.name,
      }));
      setStoreDropdownOptions(options);
    } catch (error) {
      console.error("Failed to fetch store dropdown:", error);
    }
  };

  const formConfig: FormConfig = {
    initialValues: {
      field_common_image: editExpressById?.payload
        ? Array.isArray(editExpressById?.payload?.field_common_image)
          ? editExpressById.payload.field_common_image.map((item: any, index: number) => {
              const imageUrl = typeof item === "string" ? item : item?.url || "";
              return {
                uid: `${index + 1}`,
                name: imageUrl?.trim().split("/").pop() || `image-${index + 1}.png`,
                status: "done",
                url: imageUrl?.trim(),
              };
            })
          : []
        : Array.isArray(allExpressDocs?.[0]?.field_common_image)
          ? allExpressDocs[0].field_common_image.map((item: any, index: number) => {
              const imageUrl = typeof item === "string" ? item : item?.url || "";
              return {
                uid: `${index + 1}`,
                name: imageUrl?.trim().split("/").pop() || `image-${index + 1}.png`,
                status: "done",
                url: imageUrl?.trim(),
              };
            })
          : [],

      title: editExpressById?.payload
        ? decodeHTML(editExpressById?.payload?.title)
        : decodeHTML(allExpressDocs?.[0]?.title || ""),
      body: editExpressById?.payload
        ? decodeHTML(editExpressById?.payload?.body)
        : decodeHTML(allExpressDocs?.[0]?.body || ""),
      field_common_malay_title: editExpressById?.payload
        ? decodeHTML(editExpressById?.payload?.field_common_malay_title)
        : decodeHTML(allExpressDocs?.[0]?.field_common_malay_title || ""),
      field_common_mandarin_title: editExpressById?.payload
        ? decodeHTML(editExpressById?.payload?.field_common_mandarin_title)
        : decodeHTML(allExpressDocs?.[0]?.field_common_mandarin_title || ""),
      field_common_malay_description: editExpressById?.payload
        ? decodeHTML(editExpressById?.payload?.field_common_malay_description)
        : decodeHTML(allExpressDocs?.[0]?.field_common_malay_description || ""),
      field_common_mandarin_descriptio: editExpressById?.payload
        ? decodeHTML(editExpressById?.payload?.field_common_mandarin_descriptio)
        : decodeHTML(allExpressDocs?.[0]?.field_common_mandarin_descriptio || ""),

      // field_store_location: editExpressById?.payload
      //   ? Array.isArray(editExpressById.payload.field_store_location)
      //     ? editExpressById.payload.field_store_location.map((item: any) => ({
      //         value: item.id,
      //         label: item.name,
      //       }))
      //     : []
      //   : Array.isArray(allExpressDocs?.[0]?.field_store_location)
      //     ? allExpressDocs[0].field_store_location.map((item: any) => ({
      //         value: item.id,
      //         label: item.name,
      //       }))
      //     : [],
      field_store_location: editExpressById?.payload
        ? Array.isArray(editExpressById.payload.field_store_location)
          ? editExpressById.payload.field_store_location.map((item: any) => ({
              value: String(item.id),
              label: item.label || item.name || "",
            }))
          : []
        : Array.isArray(allExpressDocs?.[0]?.field_store_location)
          ? allExpressDocs[0].field_store_location.map((item: any) => ({
              value: String(item.id),
              label: item.label || item.name || "",
            }))
          : [],
    },
    fields: fields.eXpress.map((field: any) =>
      field.name === "field_store_location" ? { ...field, options: storeDropdownOptions } : field
    ),
    // fields: fields.eXpress,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    console.log("data-123", data);
    const imageKeys = ["field_common_image"];
    for (const key of imageKeys) {
      try {
        const field = data[key];
        if (!Array.isArray(field)) continue;

        const processedUrls: string[] = [];

        for (const file of field) {
          if (file.originFileObj) {
            const formData = new FormData();
            formData.append("upload-file", file.originFileObj);
            formData.append("application", "ERAMAN");

            const res: any = await post("management/upload-file", formData);
            if (res?.response?.data) {
              processedUrls.push(res.response.data);
            }
          } else if (file.url) {
            processedUrls.push(file.url);
          }
        }

        data[key] = processedUrls;
      } catch (error) {
        console.error("error");
      }
    }

    const payload = {
      action: action,
      method: method,
      module: "Product Management",
      subModule: "eXpress",
      type: "DEDICATED",
      application: "ERAMAN",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "ERAMAN",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...(action === "UPDATE" && { id: allExpressDocs?.[0]?.id || editExpressById?.payload?.id }),
        ...data,
        // field_store_location: data.field_store_location?.map((item: any) => ({
        //   id: item.value,
        //   label: item.label,
        // })),
        field_store_location: data.field_store_location
          ?.map((item: any) => {
            if (item?.value && item?.label) {
              return { id: Number(item.value), label: item.label };
            } else if (item?.id && item?.label) {
              return { id: Number(item.id), label: item.label };
            } else if (typeof item === "string") {
              const option = storeDropdownOptions.find((opt) => opt.value === item);
              return option ? { id: Number(option.value), label: option.label } : null;
            }
            return null;
          })
          .filter(Boolean),

        status: true,
      },
      status: status,
    };

    // Log the complete payload
    console.log("payload", payload);

    // Commented out API calls for testing

    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post(`/management/publish`, payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <>
      <DynamicForm
        isLoading={isLoadingExpressDocs || isLoadingExpress}
        config={formConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${eramanHost}/api/e-xpress-list-page-crud-api/${allExpressDocs?.[0]?.id || editExpressById?.payload?.id}`,
            "UPDATE",
            "PATCH",
            buttonValue === "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
      />
    </>
  );
};
